import candidateReferences from './candidate-reference-types';

export const candidateReferencesStateKeys = {
  isLoading: 'isLoading',
  candidateReferences: 'candidateReferences',
  displayNewCandidateReferenceRequestForm:
    'displayNewCandidateReferenceRequestForm',
  candidateReferenceCountLimitReached: 'candidateReferenceCountLimitReached',
  candidateReferenceCountEnoughToApply: 'candidateReferenceCountEnoughToApply',
  submitNewCandidateReferenceRequestError:
    'submitNewCandidateReferenceRequestError'
};

export const maxCandidateReferencesCountLimit = 4;
export const minCandidateReferencesCountToApply = 2;

export const candidateReferenceTypesForRequest = [
  candidateReferences.Leadership,
  candidateReferences.Teaching,
  candidateReferences.CounselorOrLibrarian
];

export const declineReasons = {
  dontWant: 1,
  dontKnow: 2
};



// WEBPACK FOOTER //
// ./src/constants/candidate-references.js